export default () => (
  <path d="M16.2 11.56c.23.24.23.64 0 .88L9.93 18.7a.63.63 0 0 1-.88 0 .63.63 0 0 1 0-.88l5.8-5.81-5.8-5.8a.63.63 0 0 1 0-.9.63.63 0 0 1 .88 0l6.25 6.26Z" />
);
